import React from 'react';

const Modal = ({ visible, onDismiss, title, children, footer, center = false }) => {
  if (!visible) return null;

  return (
    <div
      className={`modal-overlay${center ? ' modal-overlay--center' : ''}`}
      onClick={(e) => { if (e.target === e.currentTarget) onDismiss?.(); }}
    >
      <div className={`modal-sheet${center ? ' modal-sheet--center' : ''}`}>
        <div className="modal-header">
          <span className="modal-title">{title}</span>
          <button className="modal-close-btn" onClick={onDismiss} aria-label="Close">✕</button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
